import { Suspense } from "react";
import { Spin } from 'antd'

function LazyLoad(LazyComponent) {
  return props => (
    <Suspense fallback={<LoadingIndicator />}>
      <LazyComponent {...props} />
    </Suspense>
  );
}

export default LazyLoad;

const LoadingIndicator = () => {
  return <Spin tip="Loading..." />
}